
















































import { mapState, mapActions } from 'vuex';
import Logo from '@/components/Logo.vue';
import ChromeWrapper from '@/components/chrome/Wrapper.vue';
import SidebarWrapper from '@/components/sidebar/SidebarWrapper.vue';
import InterfaceGuide from '@/components/InterfaceGuide.vue';
import { baseActions, getIcon, ISidebarAction } from './editor-constants';
import Store from './editor-store';

export default {
  props: {
    enableSidebar: {
      type: Boolean,
      default: true,
    },
    guide: {
      type: Array,
      default: () => [],
    },
    sidebarActions: {
      type: Array,
      default: () => ([]),
    },
    sidebarToggle: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    const store = Store({
      // show sidebar on desktop view
      // and if toggle button is available
      isOpen: !this.isMobile && this.sidebarToggle,
      guide: this.guide,
    });
    this.$store.registerModule('chromeEditor', store);
  },
  beforeDestroy() {
    this.$store.unregisterModule('chromeEditor');
  },
  data() {
    return {
      isMobile: this.$store.state.isMobile,
    };
  },
  computed: {
    ...mapState('chromeEditor', [
      'guideIndex',
    ]),
    actions() {
      return [
        ...this.sidebarActions,
        ...baseActions(this, this.sidebarToggle),
      ].map((action: any): ISidebarAction => {
        const icon = action.icon || getIcon(action.text || action.panel);
        const panel = action.panel;

        // add defaults to radial progress bar
        if (action.component && action.component.type === 'RadialProgress') {
          action.component.props = {
            ...action.component.props,
            radius: 44,
            width: this.isMobile ? 22 : 30,
            height: this.isMobile ? 22 : 40,
          };
        }
        return panel
          ? {
              ...action,
              icon,
              onclick: () => this.$store.dispatch('chromeEditor/selectPanel', panel),
              selected: this.$store.state.chromeEditor.panel === panel,
              text: `${panel.charAt(0).toUpperCase() + panel.substr(1).toLowerCase()}`,
            }
          : {
              ...action,
              icon,
            };
        });
    },
    isOpen() {
      const editor = this.$store.state.chromeEditor;
      return editor ? editor.isOpen : false;
    },
  },
  methods: {
    ...mapActions('chromeEditor', [
      'endGuide',
      'guideStep',
      'nextGuide',
      'startGuide',
    ]),
  },
  components: {
    ChromeWrapper,
    InterfaceGuide,
    SidebarWrapper,
    Logo,
  },
} as IView;
